import React from 'react';
import withInit from 'WithInit';
import StaticBuilderNavSideBar from './StaticBuilderNavSideBar';

class StaticBuilderNavSideBarWrapper extends React.PureComponent {
  render() {
    return (
      <StaticBuilderNavSideBar {...this.props} />
    );
  }
}

export default withInit(StaticBuilderNavSideBarWrapper, true);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderNavSideBarWrapper.jsx